<script lang="ts">

    import './global.scss';
    import { Router, Route } from 'svelte-navigator';
    import Login from './Pages/Login.svelte';
    import RouteGuard from './Components/RouteGuard.svelte';
    import Manager from './Pages/Manager/Manager.svelte';
    import Monitor from './Pages/Monitor/Monitor.svelte';
    import { SUPERADMIN_ID, MANAGER_ID } from './environment';
    import Notifications from './Components/Shared/Notifications.svelte';
    import Redirect from './Components/Shared/Redirect.svelte';
    import PrintQr from './Pages/Rooms/PrintQr.svelte';
    import { authorizationService } from './Services'
    import RedirectToUserRoleHome from './Components/RedirectToUserRoleHome.svelte';
    import { reload } from './Services/ReloadService';

    window.addEventListener('beforeunload', function (event) {
        reload.set(false);
    });

</script>

<Notifications />

<Router primary={false}>

    {#if $authorizationService}

        <!-- <Route path="/inicio">
            <RouteGuard allow={[SUPERADMIN_ID]}>
                <Dashboard />
            </RouteGuard>
        </Route>
        
        <Route path="usuarios">
            <RouteGuard allow={[SUPERADMIN_ID]}>
                <UsersList />
            </RouteGuard>
        </Route> -->

        <Route path="manager">
            <RouteGuard allow={[MANAGER_ID, SUPERADMIN_ID]}>
                <Manager />
            </RouteGuard>
        </Route>

        <!-- <Route path="cuentas/*">
            <RouteGuard allow={[SUPERADMIN_ID]}>
                <AccountsRouter />
            </RouteGuard>
        </Route> -->

        <Route path="monitor/:roomId" let:params={{ roomId }}>
            <Monitor {roomId} />
        </Route>

        <Route path="room/:roomId/print-qr" let:params={{ roomId }}>
            <PrintQr {roomId} />
        </Route>

        <Route path="*">
            <RedirectToUserRoleHome />
        </Route>
    {:else}
        <Route path="/login" component={Login} />

        <Route path="*">
            <Redirect to="/login" />
        </Route>
    {/if}

</Router>

